import { makeAutoObservable } from 'mobx'
import { restClient } from '@/Core'
import type { Notify } from '@/Ship/Contracts/Notify'

/**
 * Local store of `ResolveDelayModal`.
 * Owns the dispatcher's resolver comment, submission flag, and the resolve request.
 * Instantiated per modal mount via `useState(() => new ResolveDelayModalStore())`.
 */
/** Результат опрацювання затримки диспетчером. */
export type DelayOutcome = 'resolved' | 'not_resolved'

export class ResolveDelayModalStore {
    comment = ''
    outcome: DelayOutcome = 'resolved'
    loading = false

    constructor() {
        makeAutoObservable(this)
    }

    setComment(v: string): void {
        this.comment = v
    }

    setOutcome(v: DelayOutcome): void {
        this.outcome = v
    }

    setLoading(v: boolean): void {
        this.loading = v
    }

    reset(): void {
        this.comment = ''
        this.outcome = 'resolved'
    }

    async resolve(delayUuid: string | undefined, notify: Notify): Promise<boolean> {
        if (!delayUuid || !this.comment.trim()) return false
        this.setLoading(true)
        try {
            await restClient.post(`/services/assignment-execution-delays/${delayUuid}/resolve`, {
                json: { resolverComment: this.comment, outcome: this.outcome },
            })
            notify.success(this.outcome === 'resolved' ? 'Затримку вирішено' : 'Результат збережено')
            this.reset()
            return true
        } catch {
            notify.error('Помилка збереження')
            return false
        } finally {
            this.setLoading(false)
        }
    }
}
